import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { CopyTariffProposalItemForRecalCriteria } from "domain/entity/ProposalCopyingForRecal/CopyTariffProposalItemForRecalCriteria";
import { ProposalCopyingForRecalEntity } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalEntity";
import { ProposalCopyingForRecalItemEntity } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalItemEntity";
import { ProposalCopyingForRecalSearchCriteria } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import tariffAxiosInstance from "../axios/tariffAxiosInstance";
import { ProposalCopyingForRecalRepository } from "./ProposalCopyingForRecalRepo";

export const ProposalCopyingForRecalRepoImpl = (): ProposalCopyingForRecalRepository => {

    const getEntities = async (searchCriteria: ProposalCopyingForRecalSearchCriteria): Promise<ProposalCopyingForRecalEntity[]> => {
        const url = '/v1/proposalCopyingForRecal';
        return axiosPostData(tariffAxiosInstance, url, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchRecalProposal = async (searchCriteria: ProposalCopyingForRecalSearchCriteria): Promise<ProposalCopyingForRecalEntity[]> => {
        const url = '/v1/searchRecalProposal';
        return axiosPostData(tariffAxiosInstance, url, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const getTariffItems = async (entity: ProposalCopyingForRecalEntity): Promise<ProposalCopyingForRecalItemEntity[]> => {
        const url = '/v1/getTariffItemsForRecal';
        return axiosPostData(tariffAxiosInstance, url, entity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }


    const copyProposalTariffItemsForRecal = async (searchCriteria: CopyTariffProposalItemForRecalCriteria): Promise<ResponseEntity> => {
        const url = '/v1/copyProposalTariffItemsForRecal';
        return await axiosPostData(tariffAxiosInstance, url, searchCriteria);
    }

    const deleteItems = async (items: ProposalCopyingForRecalItemEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/deleteItemsForRecal';
        return await axiosPostData(tariffAxiosInstance, url, items);
    }

    const saveItem = async (item: ProposalCopyingForRecalItemEntity): Promise<ResponseEntity> => {
        const url = '/v1/saveItemForRecal';
        return await axiosPostData(tariffAxiosInstance, url, item);
    }


    return {
        getEntities: getEntities,
        getTariffItems: getTariffItems,
        searchRecalProposal: searchRecalProposal,
        copyProposalTariffItemsForRecal: copyProposalTariffItemsForRecal,
        deleteItems: deleteItems,
        saveItem: saveItem,
    }
}